<template>
    <v-dialog v-model="showDialog" max-width="500" data-id="bookingCancelDialog">
        <template #activator="tmplProps">
            <slot name="activator" v-bind="tmplProps" />
        </template>

        <v-card rounded="lg">
            <v-card-title class="d-flex justify-center pt-4 pb-0 px-6">
                <div class="text-h3">{{ t('booking.resources.cancelDialogTitle') }}</div>
            </v-card-title>
            <v-card-text class="text-body-1 font-weight-regular text-secondary py-4 pt-4 pb-8">
                {{ t('booking.resources.cancelDialogDescription', { quayName }) }}
            </v-card-text>
            <v-divider class="opacity-100 mx-6" />
            <v-card-actions color="secondary" class="px-6 pt-6 pb-4">
                <v-defaults-provider :defaults="actionBtnOptions">
                    <v-row>
                        <v-col cols="6">
                            <v-btn color="primary" variant="outlined" data-id="bookingCancelDialogDismissBtn" @click="showDialog = false">
                                {{ t('common.resources.cancel') }}
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn color="red-darken-2" variant="flat" data-id="bookingCancelDialogConfirmBtn" @click="onCancelBtnClick">
                                {{ t('booking.resources.cancelBooking') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-defaults-provider>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { BookingDto } from '@/types/webapi';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
    booking?: BookingDto;
}

interface Emits {
    (e: 'cancel-booking'): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { t } = useI18n();
const showDialog = ref(false);
const quayName = computed(() => props.booking?.pickupQuayName);
const actionBtnOptions = {
    VBtn: {
        block: true,
        size: 'x-large',
        rounded: 'lg',
        class: 'text-h6 font-weight-bold'
    }
};

function onCancelBtnClick() {
    showDialog.value = false;
    emit('cancel-booking');
}
</script>
